import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { checkHasFiles, deleteFile, downloadFile } from "src/utils/file-utils";
import { DeleteButton, TextButton } from "..";

const DisplayFiles = ({ storagePath, allowDelete = false, className }) => {
  const [fileRefs, setFileRefs] = useState([]);

  useEffect(() => {
    if (!storagePath) return;
    checkHasFiles(storagePath, setFileRefs);
  }, [storagePath]);

  if (!fileRefs.length) return null;

  return (
    <div className={`d-flex flex-column align-items-start ${className}`}>
      {fileRefs.map((fileRef,idx) => (
        <small key={idx} className="text-info mb-2">
          File:{" "}
          <TextButton
            type="button"
            className={"text-info font-bold"}
            onClick={() => downloadFile(fileRef)}
          >
            {fileRef.name}
          </TextButton>
          {allowDelete && (
            <DeleteButton
              size="sm"
              style={{ border: "none" }}
              className="ml-1 p-1"
              onClick={() => deleteFile(fileRef)}
            />
          )}
        </small>
      ))}
    </div>
  );
};

export default DisplayFiles;
